/**
 * Deepgram Nova 2 Speach to Text Languages - https://developers.deepgram.com/docs/models-languages-overview#nova-2
 **/

export enum DeepgramSTTLanguage {
  'Multilingual (Spanish + English)' = 'multi',
  'Bulgarian' = 'bg',
  'Catalan' = 'ca',
  'Chinese' = 'zh',
  'Chinese (Simplified)' = 'zh-CN',
  'Chinese (Traditional)' = 'zh-Hant',
  'Chinese (Cantonese)' = 'zh-HK',
  'Czech' = 'cs',
  'Danish' = 'da',
  'Danish (Denmark)' = 'da-DK',
  'Dutch' = 'nl',
  'English' = 'en',
  'English (US)' = 'en-US',
  'English (Australia)' = 'en-AU',
  'English (United Kingdom)' = 'en-GB',
  'English (New Zealand)' = 'en-NZ',
  'English (India)' = 'en-IN',
  'Estonian' = 'et',
  'Finnish' = 'fi',
  'Flemish' = 'nl-BE',
  'French' = 'fr',
  'French (Canada)' = 'fr-CA',
  'German' = 'de',
  'German (Switzerland)' = 'de-CH',
  'Greek' = 'el',
  'Hindi' = 'hi',
  'Hungarian' = 'hu',
  'Indonesian' = 'id',
  'Italian' = 'it',
  'Japanese' = 'ja',
  'Korean' = 'ko',
  'Korean (South Korea)' = 'ko-KR',
  'Latvian' = 'lv',
  'Lithuanian' = 'lt',
  'Malay' = 'ms',
  'Norwegian' = 'no',
  'Polish' = 'pl',
  'Portuguese' = 'pt',
  'Portuguese (Brazil)' = 'pt-BR',
  'Portuguese (Portugal)' = 'pt-PT',
  'Romanian' = 'ro',
  'Russian' = 'ru',
  'Slovak' = 'sk',
  'Spanish' = 'es',
  'Spanish (Latin America)' = 'es-419',
  'Swedish' = 'sv',
  'Swedish (Sweden)' = 'sv-SE',
  'Thai' = 'th',
  'Thai (Thailand)' = 'th-TH',
  'Turkish' = 'tr',
  'Ukrainian' = 'uk',
  'Vietnamese' = 'vi'

}